/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import { type ForwardedRef, forwardRef } from 'react';
import { type IconProps, Icon } from '../../components/icon/icon.component';

const SocialsGoogleColorFillIcon = forwardRef((props: IconProps, ref: ForwardedRef<SVGSVGElement>) => {
  return (
    <Icon isFilled isColored {...props} ref={ref}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
          d="M21 12.3878C21 11.6327 20.9388 11.0817 20.8062 10.5103H12.1837V13.9184H17.2449C17.1429 14.7653 16.5919 16.0409 15.3674 16.898L15.3502 17.0121L18.0765 19.1241L18.2653 19.1429C20 17.5408 21 15.1837 21 12.3878Z"
          fill="#4285F4"
        />
        <path
          d="M12.1837 21.3673C14.6633 21.3673 16.7449 20.551 18.2653 19.1429L15.3674 16.8979C14.5919 17.4387 13.551 17.8163 12.1837 17.8163C9.75516 17.8163 7.69395 16.2143 6.95919 14L6.85149 14.0091L4.01669 16.203L3.97961 16.3061C5.4898 19.3061 8.59185 21.3673 12.1837 21.3673Z"
          fill="#34A853"
        />
        <path
          d="M6.95914 14C6.76527 13.4285 6.65307 12.8163 6.65307 12.1836C6.65307 11.5509 6.76527 10.9387 6.94894 10.3673L6.94381 10.2456L4.07348 8.01648L3.97957 8.06115C3.35715 9.30606 3 10.704 3 12.1836C3 13.6632 3.35715 15.0611 3.97957 16.3061L6.95914 14Z"
          fill="#FBBC05"
        />
        <path
          d="M12.1837 6.551C13.9082 6.551 15.0714 7.29589 15.7347 7.91838L18.3265 5.38775C16.7348 3.90817 14.6633 3 12.1837 3C8.59185 3 5.4898 5.06121 3.97961 8.06118L6.94899 10.3673C7.69395 8.15306 9.75516 6.551 12.1837 6.551Z"
          fill="#EB4335"
        />
      </svg>
    </Icon>
  );
});

export { SocialsGoogleColorFillIcon };
